import './App.css'
import Navbar from './Navbar'
import Home from './Component/Pages/Home'
import Info from './Component/Pages/Info'
import Administrator from './Component/Pages/Administrator'
import SocialSubject from './Component/Pages/SocialSubject'
import LanguageSubject from './Component/Pages/LanguageSubject'
import PhysicalEduSubject from './Component/Pages/PhysicalEduSubject'
import CareerSubject from './Component/Pages/CareerSubject'
import ScienceSubject from './Component/Pages/ScienceSubject'
import ArtSubject from './Component/Pages/ArtSubject'
import ThaiSubject from './Component/Pages/ThaiSubject'
import MathSubject from './Component/Pages/MathSubject'
import Admin from './Component/Pages/Admin'
import ContactUs from './Component/Pages/ContactUs'
import { Route, Routes } from 'react-router-dom'
import Login from './Component/Pages/Login'
import './App.css';


function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path="/information/history" element={<Info />} />
        <Route path="/information/administrator" element={<Administrator />} />
        <Route path="/subject/social" element={<SocialSubject />} />
        <Route path="/subject/english" element={<LanguageSubject />} />
        <Route path="/subject/health" element={<PhysicalEduSubject />} />
        <Route path="/subject/career" element={<CareerSubject />} />
        <Route path="/subject/art" element={<ArtSubject />} />
        <Route path="/subject/science" element={<ScienceSubject />} />
        <Route path="/subject/thai" element={<ThaiSubject />} />
        <Route path="/subject/math" element={<MathSubject />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path='/login/*' element={<Login/>} />
      </Routes> 
  
    </>
  )

}

export default App;
